import Vue from '@triotech/vue-core/src/vendor/vue';
import I18n from '@triotech/vue-core/src/plugins/i18n';

const Helper = new Vue({
  i18n: I18n,
  computed: {
    isLegacy() {
      return this.$config.get('legacy');
    },
    playerKind() {
      return this.get().player;
    },
    enums() {
      return this.get().enums;
    },
    playerEnums() {
      return this.enums.player;
    },
    isPlayerEval() {
      return this.playerKind === this.playerEnums.eval;
    },
    isPlayerCertif() {
      return this.playerKind === this.playerEnums.certif;
    },
    isPlayerPrepa() {
      return this.playerKind === this.playerEnums.prepa;
    },
    isPlayerDemo36() {
      return this.playerKind === this.playerEnums.demo36;
    },
    isPlayerDemo12() {
      return this.playerKind === this.playerEnums.demo12;
    },
    testTitle() {
      if (this.isLegacy) {
        return this.$t(`legacy.test.${this.playerKind}.title`);
      }

      return this.$t('test.title');
    },
  },
  methods: {
    getEnums() {
      return new Promise((resolve, reject) => {
        if (this.enums) {
          resolve(this.enums);
        } else {
          Promise.all(['player'].map(this.fetchEnums)).then(() => {
            resolve(this.enums);
          }).catch(reject);
        }
      });
    },
    fetchEnums(kind) {
      return this.$ajax.publicRequest(`public/enum/${kind}_enum`).then((data) => {
        let { enums } = this.get();
        if (!enums) {
          enums = {};
        }

        enums[kind] = data;
        this.set({ enums });
      });
    },
    getImage(uploadFilePath) {
      if (this.$helper.isPlayerDemo12) {
        const hash = this.$hash(uploadFilePath);
        if (!this[hash]) {
          this[hash] = window.URL.createObjectURL(this._.base64ToBlob(uploadFilePath));
        }
        return this[hash];
      }
      if (this.$config.get('legacy')) {
        return this.$ajax.url(uploadFilePath, true);
      }
      return this.$ajax.getUploadsUri(uploadFilePath);
    },
    setLocale(locale) {
      const [shortLocale] = locale.toLowerCase().match(/([a-z]+)/) || [];

      if (shortLocale) {
        this.$i18n.locale = shortLocale;
        this.$moment.locale(shortLocale);
      }
    },
  },
});

Vue.set(Vue.prototype, '$helper', Helper);

export default Helper;
